exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".to-storage-edit div > div.flex {\n  position: relative;\n  top: 10px; }\n\n@media only screen and (max-width: 768px) {\n  .to-storage-edit {\n    max-height: calc(100vh - 160px);\n    min-height: calc(100vh - 160px);\n    overflow-y: auto;\n    padding: 0 16px; }\n    .to-storage-edit .list-tabs {\n      width: 100%; } }\n\n@media only screen and (max-width: 600px) {\n  .to-storage-container {\n    width: calc(100vw - 10px);\n    padding-left: 5px;\n    padding-right: 5px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/toStorage/index.scss
// module id = 7085
// module chunks = 0